import { Content } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import styles from './StatsTable.module.scss';
import { PrismicNextImage } from '@prismicio/next';
import { Checkmark } from '@/assets/icons/Checkmark';

interface Props {
  data: Content.IncomeBasedHeroSlice;
}

const StatsTable = ({ data }: Props) => {
  return (
    <article className={styles.wrapper}>
      <h3 className={styles.title}>
        <PrismicRichText field={data.primary.table_title} />
      </h3>
      <div className={styles.line} />
      <div className={styles.infoWrapper}>
        <p className={styles.subtitle}>{data.primary.table_subtitle}</p>
        <ul className={styles.list}>
          {data.primary.table_list.map((item) => (
            <li key={item.label} className={styles.listItem}>
              <Checkmark className={styles.checkmark} />
              <span className={styles.labelTitle}>{item.label}</span>
              <span className={styles.labelValue}>{item.value}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.line} />
      <div className={styles.disclaimerWrapper}>
        <PrismicNextImage
          className={styles.icon}
          field={data.primary.table_icon}
        />
        <p className={styles.text}>{data.primary.table_slogan}</p>
      </div>
    </article>
  );
};

export default StatsTable;
